export default __webpack_public_path__ + "static/media/Footer-Icon-Chat.cddc126f.png";